import { useEffect, useState } from "react";
import { UserCheck } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";
import { cameraLabels } from "../../lib/kycApi";
import { useAuth } from "../../context/AuthContext";
import { PageHeader } from "../../components/PageHeader";
import { KycFlow } from "../../components/kyc/KycFlow";
import { Button } from "../../components/ui/button";

export default function Presencial() {
  const { me } = useAuth();
  const [company, setCompany] = useState(null);
  const [session, setSession] = useState(null);
  useEffect(() => {
    api.get("/company").then((r) => setCompany(r.data));
  }, []);

  const start = async () => {
    try {
      const { data } = await api.post("/company/kyc/presencial", { camaras: await cameraLabels() });
      setSession(data);
    } catch (e) {
      toast.error(errMsg(e));
    }
  };

  if (!company) return null;
  const brand = { nombre: company.marca.nombre_visible || company.nombre_fantasia, color: company.marca.color, tiene_logo: false, slug: company.slug };
  if (session) {
    return (
      <div className="space-y-4 -m-4 sm:-m-6 lg:-m-10" data-testid="presencial-flow">
        <div className="px-4 pt-4"><Button variant="outline" onClick={() => setSession(null)} data-testid="presencial-new-button">Cerrar y empezar otra verificación</Button></div>
        <KycFlow key={session.session_id} brand={brand} session={session} mode="presencial" operador={me.usuario.nombre} onRestart={() => setSession(null)} />
      </div>
    );
  }
  return (
    <div className="space-y-8">
      <PageHeader overline="Atención en oficina" title="KYC presencial" />
      <div className="bg-white border border-slate-200 rounded-xl p-6 space-y-4 max-w-xl">
        <UserCheck className="text-blue-700" />
        <p className="text-sm text-slate-600">Usa el mismo formulario y las mismas fotos que el link remoto. Al final deberás confirmar que verificaste presencialmente que la persona coincide con su documento.</p>
        {company.estado !== "activa" && <p className="text-sm text-amber-700" data-testid="presencial-locked">Disponible cuando IntiCheck active tu empresa.</p>}
        <Button onClick={start} disabled={company.estado !== "activa" || me.soporte} className="bg-slate-900 hover:bg-slate-800" data-testid="presencial-start-button">Iniciar verificación presencial</Button>
      </div>
    </div>
  );
}
